import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import getStore from '../store';
import { getLocale } from '@alltrails/shared/utils/languageSupport';
import Locale from '@alltrails/shared/types/Locale';

type Props = {
  children?: React.ReactNode;
};

function CustomProvider({ children }: Props) {
  const languageRegionCode = useLanguageRegionCode();
  const locale = getLocale(languageRegionCode);
  const messages = global.__TRANSLATION_JSON__;

  return (
    <Provider store={getStore()}>
      <IntlProvider defaultLocale={Locale.English} locale={locale} messages={messages}>
        {children}
      </IntlProvider>
    </Provider>
  );
}

export default CustomProvider;
